export default "__VITE_ASSET__f31810f2__"